var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.40625 12.75L1.21875 7.5625C0.90625 7.25 0.90625 6.71875 1.21875 6.40625L2.34375 5.28125C2.65625 4.96875 3.15625 4.96875 3.46875 5.28125L7 8.78125L14.5 1.28125C14.8125 0.96875 15.3125 0.96875 15.625 1.28125L16.75 2.40625C17.0625 2.71875 17.0625 3.25 16.75 3.5625L7.5625 12.75C7.25 13.0625 6.71875 13.0625 6.40625 12.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck2);
export default __webpack_public_path__ + "static/media/check2.6e91388fc1588e8d7bd29aa819eff1a2.svg";
export { ForwardRef as ReactComponent };